/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibraryfilterlabel3Inputs */

const en_medialibraryfilterlabel3 = /** @type {(inputs: Medialibraryfilterlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by tool`)
};

const de_medialibraryfilterlabel3 = /** @type {(inputs: Medialibraryfilterlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Werkzeug filtern`)
};

/**
* | output |
* | --- |
* | "Filter by tool" |
*
* @param {Medialibraryfilterlabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibraryfilterlabel3 = /** @type {((inputs?: Medialibraryfilterlabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibraryfilterlabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibraryfilterlabel3(inputs)
	return de_medialibraryfilterlabel3(inputs)
});
export { medialibraryfilterlabel3 as "mediaLibraryFilterLabel" }